import { isSameDay } from "date-fns";
import { cn } from "@/lib/utils";
import { OrderWithRelations } from "./types";
import { ScheduleOrderCell } from "./ScheduleOrderCell";
import { Location } from "@/types/tms";

interface ScheduleTableRowProps {
  locationId: string;
  locationName: string;
  orders: OrderWithRelations[];
  weekDays: Date[];
  onOrderClick?: (order: OrderWithRelations) => void;
  locations?: Location[];
}

export function ScheduleTableRow({
  locationId,
  locationName,
  orders,
  weekDays,
  onOrderClick,
  locations,
}: ScheduleTableRowProps) {
  // Group orders by day
  const ordersByDay = weekDays.map((day) =>
    orders
      .filter((order) => isSameDay(new Date(order.ready_time), day))
      .sort((a, b) => new Date(a.ready_time).getTime() - new Date(b.ready_time).getTime())
  );

  return (
    <tr className="border-b last:border-b-0">
      <td className="w-[200px] min-w-[200px] max-w-[200px] shrink-0 p-3 font-medium text-sm border-r align-top sticky left-0 z-10 bg-popover">
        {locationName}
      </td>
      {weekDays.map((day, dayIndex) => {
        const dayOrders = ordersByDay[dayIndex];

        return (
          <td
            key={day.toISOString()}
            className={cn(
              "p-2 border-r last:border-r-0 align-top min-w-[180px]",
              isSameDay(day, new Date()) && "bg-primary/5"
            )}
          >
            {dayOrders.length > 0 ? (
              <div className="flex flex-col gap-1">
                {dayOrders.map((order) => (
                  <ScheduleOrderCell
                    key={order.id}
                    order={order}
                    onClick={() => onOrderClick?.(order)}
                    locations={locations}
                  />
                ))}
              </div>
            ) : (
              <div className="h-10" />
            )}
          </td>
        );
      })}
    </tr>
  );
}
